import paypalIcon from './assets/paypal_color.svg';

export const PayPalLogo = () => <img src={paypalIcon} alt="" role="presentation" className="paypal-icon-img" />;
